import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";
import MainPage from "./pages/MainPage";
import GlobalStyle from "./styles/GlobalStyles";
import Login from "./pages/login/Login";
import SignUp from "./pages/signup/SignUp";
import TermsOfUse from "./pages/signup/TermsOfUse";
import AddUserInfo from "./pages/signup/AddUserInfo";
import SettingPassword from "./pages/signup/SettingPassword";
import SignUpResult from "./pages/signup/SignUpResult";
import FindId from "./pages/login/FindId";
import FindIdResult from "./pages/login/FindIdResult";
import FindPassword from "./pages/login/FindPassword";
import FindPwResult from "./pages/login/FindPwResult";
import ReSettingPassword from "./pages/login/ReSettingPassword";
import IntroducePage from "./pages/IntroducePage";
import IntroducePartnersPage from "./pages/IntroducePartnersPage";
import PartnersGuidePage from "./pages/PartnersGuidePage";
import IntroducePartnersDetailPage from "./pages/IntroducePartnersDetailPage";
import PointChangePage from "./pages/PointChangePage";
import PointChangePeerPage from "./pages/PointChangePeerPage";
import PointChangeResultPage from "./pages/PointChangeResultPage";
import StartPage from "./pages/StartPage";
import MyPageRoutes from "./components/routes/MyPageRoutes";
import CheckPw from "./pages/myPage/CheckPw";
import MyInfoEditRoutes from "./components/routes/MyInfoEditRoutes";
import EditInfoResult from "./pages/myPage/EditInfoResult";
import MyPoint from "./pages/myPage/MyPoint";
import MyInquiry from "./pages/myPage/MyInquiry";
import WithDrawal from "./pages/myPage/WithDrawal";
import EditInfoPassword from "./pages/myPage/EditInfoPassword";
import WithDrawalResult from "./pages/myPage/WithDrawalResult";
import NeedLogin from "./pages/myPage/NeedLogin";
import Notice from "./pages/service/Notice";
import Faq from "./pages/service/Faq";
import UserGuidePage from "./pages/UserGuidePage";
import SettingPage from "./pages/SettingPage";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "./store/slices/userSlice";
import { getToken, returnLoginStatus } from "./components/hooks/authFunc";
import DanalResponse from "./pages/signup/DanalResponse";
import AmoHistory from "./pages/amo/AmoHistory";
import AmoPointChangeHome from "./pages/amo/AmoPointChangeHome";
import CheckWallet from "./pages/amo/CheckWallet";
import WalletGuide from "./pages/amo/WalletGuide";
import AddWallet from "./pages/amo/AddWallet";
import AddNewWallet from "./pages/amo/AddNewWallet";
import AmoChange from "./pages/amo/AmoChange";
import AmoChangeCurrent from "./pages/amo/AmoChangeCurrent";
import AmoChangeResult from "./pages/amo/AmoChangeResult";
import IntroducePartnersAppsPage from "./pages/IntroducePartnersAppsPage";
import SignGuide from "./pages/amo/SignGuide";
import Healthcheck from "./pages/Healthcheck";
import EasySignUp from "./pages/signup/EasySignUp";
import RouterComponent from "./components/routes/RouterComponent";

function App() {
  const dispatch = useDispatch();
  const accessToken = getToken();
  const [showStartPage, setShowStartPage] = useState(true);
  const isShowStartPage = useSelector((state) => state.main.isShowStartPage);

  useEffect(() => {
    if (returnLoginStatus()) getData();
  }, []);

  useEffect(() => {
    if (!isShowStartPage) {
      setShowStartPage(false); // 로그인되면 StartPage를 다시 표시하지 않음
    }
  }, [isShowStartPage]);

  const getData = () => {
    const params = {};
    dispatch(userActions.fetchUserLookup({ params, accessToken }));
  };

  // console.log("urls", process.env.REACT_APP_BASE_URL);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <RouterComponent>
          {showStartPage && <Route path="/" element={<StartPage />} />}
          {/* <Route path="/" element={<StartPage />} /> */}
          <Route path="/home" element={<MainPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/sign-up/terms-of-use" element={<TermsOfUse />} />
          <Route path="/sign-up/add-user-info" element={<AddUserInfo />} />
          <Route
            path="/sign-up/setting-password"
            element={<SettingPassword />}
          />
          <Route path="/sign-up/result" element={<SignUpResult />} />
          <Route path="/danal/response" element={<DanalResponse />} />
          <Route path="/find/id" element={<FindId />} />
          <Route path="/find/id/result" element={<FindIdResult />} />
          <Route path="/find/password" element={<FindPassword />} />
          <Route path="/find/password/result" element={<FindPwResult />} />
          <Route path="/resetting/password" element={<ReSettingPassword />} />
          <Route path="/required/login" element={<NeedLogin />} />

          <Route path="/easy-sign-up" element={<EasySignUp />} />
          {/* 제휴 */}
          <Route path="/introduce" element={<IntroducePage />} />
          <Route
            path="/introduce/partners"
            element={<IntroducePartnersPage />}
          />
          <Route
            path="/introduce/partners/apps"
            element={<IntroducePartnersAppsPage />}
          />
          <Route
            path="/introduce/partners/detail"
            element={<IntroducePartnersDetailPage />}
          />
          <Route path="/guide" element={<PartnersGuidePage />} />

          {/* login 해야지 접근 할 수 있는 페이지(amo메뉴 ,my page메뉴, 포인트메뉴) */}
          <Route element={<MyPageRoutes />}>
            {/* amo */}
            <Route path="/amo/init" element={<AmoPointChangeHome />} />
            <Route path="/amo/wallet/check" element={<CheckWallet />} />
            <Route path="/amo/sign/guide" element={<SignGuide />} />
            <Route path="/amo/wallet/guide" element={<WalletGuide />} />
            <Route path="/amo/wallet/add" element={<AddWallet />} />
            <Route path="/amo/wallet/new" element={<AddNewWallet />} />
            <Route path="/amo/change/init" element={<AmoChange />} />
            <Route path="/amo/change/current" element={<AmoChangeCurrent />} />
            <Route path="/amo/change/result" element={<AmoChangeResult />} />
            <Route path="/amo/history" element={<AmoHistory />} />

            {/* 포인트 */}
            <Route path="/point/change" element={<PointChangePage />} />
            <Route
              path="/point/change/peer"
              element={<PointChangePeerPage />}
            />
            <Route
              path="/point/change/result"
              element={<PointChangeResultPage />}
            />
            {/* 마이페이지 */}
            <Route path="/mypage/edit" element={<CheckPw />} />
            <Route
              path="/mypage/edit/password"
              element={<EditInfoPassword />}
            />
            <Route path="/mypage/edit/result" element={<EditInfoResult />} />
            <Route path="/mypage/withdrawal" element={<WithDrawal />} />
            <Route
              path="/mypage/withdrawal/result"
              element={<WithDrawalResult />}
            />

            <Route path="/mypage/point" element={<MyPoint />} />
            <Route path="/mypage/inquiry" element={<MyInquiry />} />
          </Route>

          <Route path="/service/notice" element={<Notice />} />
          <Route path="service/faq" element={<Faq />} />
          <Route path="/setting" element={<SettingPage />} />
          <Route path="/user-guide" element={<UserGuidePage />} />
          <Route path="/healthcheck" element={<Healthcheck />} />
        </RouterComponent>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
